// Flattens a top-level shapes[] tree down to just the class/interface shape
// instances — including ones nested inside a UmlPackageShape's children[],
// recursively (a package can contain packages). Duck-typed on
// {caption, members[]} rather than instanceof, so this file doesn't need to
// import UmlClassShape at all — a UmlCommentShape has neither, a
// UmlPackageShape has children but no caption/members of its own.
// Shared by AssociationConnectorBuilder.js and InheritanceConnectorBuilder.js
// so both retroactive canvas-scans (see CanvasConnectorFinder.js) flatten
// packages the same way.
export function flattenClassShapes(shapes) {
    const result = [];
    shapes.forEach(function collect(shape) {
        if (shape.caption && Array.isArray(shape.members)) {
            result.push(shape);
        }
        if (Array.isArray(shape.children)) {
            result.push(...flattenClassShapes(shape.children));
        }
    });
    return result;
}
